var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44621 0.397052C1.1526 0.179197 0.735936 0.203403 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L5.93934 7L0.469671 12.4697C0.176777 12.7626 0.176777 13.2374 0.469671 13.5303C0.735937 13.7966 1.1526 13.8208 1.44621 13.6029L1.53033 13.5303L7 8.06066L12.4697 13.5303L12.5538 13.6029C12.8474 13.8208 13.2641 13.7966 13.5303 13.5303C13.8232 13.2374 13.8232 12.7626 13.5303 12.4697L8.06066 7L13.5303 1.53033C13.8232 1.23744 13.8232 0.762563 13.5303 0.46967C13.2641 0.203403 12.8474 0.179197 12.5538 0.397052L12.4697 0.46967L7 5.93934L1.53033 0.46967L1.44621 0.397052Z",
    fill: "black"
  })));
};
export default SvgCloseIcon;